import _IconQuestionCircle from "@arco-design/web-react/icon/react-icon/IconQuestionCircle";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconSearch from "@arco-design/web-react/icon/react-icon/IconSearch";
import _IconStamp from "@arco-design/web-react/icon/react-icon/IconStamp";
import _IconCommon from "@arco-design/web-react/icon/react-icon/IconCommon";
import _IconTool from "@arco-design/web-react/icon/react-icon/IconTool";
import _IconStorage from "@arco-design/web-react/icon/react-icon/IconStorage";
import _IconCalendarClock from "@arco-design/web-react/icon/react-icon/IconCalendarClock";
import _IconSelectAll from "@arco-design/web-react/icon/react-icon/IconSelectAll";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconSubscribed from "@arco-design/web-react/icon/react-icon/IconSubscribed";
import React, { useState, useMemo, useRef, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import MermaidChart from '../MermaidChart';
import { qaData, searchQA } from '../qaData';
import styles from '../style/index.module.less';
const overviewChart = `graph LR
    A["录单"] --> B["算料"]
    B --> C["采购"]
    B --> D["生产"]
    C --> E["收货品检"]
    E --> F["入库"]
    F --> G["生产领料"]
    G --> D
    F --> H["销售发货"]
    D --> I["成品入库"]
    I --> H
    F -.-> J["对账付款"]

    style B fill:#FFF3E0,stroke:#FF9800
    style G fill:#E8F5E9,stroke:#4CAF50
    style H fill:#FFF9C4,stroke:#FFC107`;
const roles = [{
  name: '销售',
  desc: '我有订单要录入，要发货给客户',
  icon: _IconSubscribed,
  link: '/help/sales',
  theme: 'grad-blue'
}, {
  name: '需求提报人',
  desc: '我需要提报物料需求，想看审批进度',
  icon: _IconFile,
  link: '/help/demand',
  theme: 'grad-green'
}, {
  name: '采购',
  desc: '我要询价比价、下采购单、跟供应商交期',
  icon: _IconSelectAll,
  link: '/help/purchase',
  theme: 'grad-orange'
}, {
  name: '供应商',
  desc: '我是供应商，要报价、发货、看对账单',
  icon: _IconCalendarClock,
  link: '/help/supplier',
  theme: 'grad-teal'
}, {
  name: '仓管',
  desc: '我要收货、品检、拣料发货',
  icon: _IconStorage,
  link: '/help/warehouse',
  theme: 'grad-purple'
}, {
  name: '生产',
  desc: '我有工单要开工，要领料、报工',
  icon: _IconTool,
  link: '/help/production',
  theme: 'grad-red'
}, {
  name: '研发/产品',
  desc: '我要维护物料和 BOM，设置计划参数',
  icon: _IconCommon,
  link: '/help/product',
  theme: 'grad-indigo'
}, {
  name: '财务',
  desc: '我要对账、安排付款、处理费用、管理发票',
  icon: _IconStamp,
  link: '/help/finance',
  theme: 'grad-steel'
}];
export default function Home() {
  const history = useHistory();
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const debounceRef = useRef();
  const handleQueryChange = useCallback(value => {
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => setDebouncedQuery(value), 300);
  }, []);
  const searchResults = useMemo(() => {
    if (!debouncedQuery.trim()) return [];
    return searchQA(debouncedQuery, qaData).slice(0, 5);
  }, [debouncedQuery]);
  const searchKeywords = debouncedQuery.trim() ? debouncedQuery.trim().split(/\s+/).filter(Boolean) : [];
  const highlightText = (text, keywords) => {
    if (!keywords.length) return text;
    let result = text;
    keywords.forEach(kw => {
      if (!kw) return;
      const regex = new RegExp(`(${kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      result = result.replace(regex, `<span class="${styles['qa-highlight']}">$1</span>`);
    });
    return result;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles['help-home']
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles['help-home-title']
  }, "\u5E2E\u52A9\u4E2D\u5FC3"), /*#__PURE__*/React.createElement("p", {
    className: styles['help-home-subtitle']
  }, "\u4E86\u89E3\u7CFB\u7EDF\u5168\u6D41\u7A0B\uFF0C\u5FEB\u901F\u627E\u5230\u4F60\u9700\u8981\u7684\u64CD\u4F5C\u6307\u5F15"), /*#__PURE__*/React.createElement("div", {
    className: styles['home-search-banner']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['home-search-left']
  }, /*#__PURE__*/React.createElement(_IconSearch, {
    className: styles['home-search-banner-icon']
  }), /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconSearch, {
      style: {
        visibility: 'hidden'
      }
    }),
    placeholder: "\u641C\u7D22\u4F60\u9047\u5230\u7684\u95EE\u9898\uFF0C\u4F8B\u5982\uFF1A\u5DE5\u5355\u600E\u4E48\u6682\u505C\uFF1F",
    allowClear: true,
    size: "large",
    value: query,
    onChange: handleQueryChange
  })), /*#__PURE__*/React.createElement(Link, {
    to: "/help/qa",
    className: styles['home-qa-btn'],
    style: {
      height: 36,
      lineHeight: '36px'
    }
  }, /*#__PURE__*/React.createElement(_IconQuestionCircle, null), "\u95EE\u7B54\u4E2D\u5FC3"), searchResults.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles['home-search-results']
  }, searchResults.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id,
    className: styles['home-search-item'],
    onClick: () => history.push(item.link)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['home-search-item-q'],
    dangerouslySetInnerHTML: {
      __html: highlightText(item.question, searchKeywords)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['home-search-item-summary'],
    dangerouslySetInnerHTML: {
      __html: highlightText(item.summary, searchKeywords)
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['home-search-more'],
    onClick: () => history.push('/help/qa')
  }, "\u67E5\u770B\u66F4\u591A\u7ED3\u679C\uFF0C\u8FDB\u5165\u95EE\u7B54\u4E2D\u5FC3 \u2192"))), /*#__PURE__*/React.createElement("div", {
    className: styles['overview-entry']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['overview-entry-title']
  }, "\u4E1A\u52A1\u5168\u666F\u56FE"), /*#__PURE__*/React.createElement("div", {
    className: styles['overview-entry-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: overviewChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['overview-entry-link']
  }, "\u60F3\u4E86\u89E3\u5168\u5C40\uFF1F\u67E5\u770B ", /*#__PURE__*/React.createElement(Link, {
    to: "/help/overview"
  }, "\u4E1A\u52A1\u5168\u666F\u56FE"))), /*#__PURE__*/React.createElement("div", {
    className: styles['role-section-title']
  }, "\u627E\u5230\u4F60\u7684\u89D2\u8272\uFF0C\u770B\u64CD\u4F5C\u6307\u5F15"), /*#__PURE__*/React.createElement("div", {
    className: styles['role-grid']
  }, roles.map(role => {
    const Icon = role.icon;
    return /*#__PURE__*/React.createElement(Link, {
      key: role.name,
      to: role.link,
      className: `${styles['role-card']} ${styles[role.theme]}`
    }, /*#__PURE__*/React.createElement(Icon, {
      className: styles['role-card-icon']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['role-card-name']
    }, role.name), /*#__PURE__*/React.createElement("div", {
      className: styles['role-card-desc']
    }, role.desc));
  })));
}